var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"category-container"},_vm._l((_vm.list),function(item){return _c('li',{key:item.id},[_c('span',{class:{ active: item.isSelect },on:{"click":function($event){return _vm.hanleSelect(item)}}},[_vm._v(_vm._s(item.name)+"   "+_vm._s(item.aside))]),_c('Category',{attrs:{"list":item.children},on:{"select":_vm.hanleSelect}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }